import { getToken } from "../utils/getToken";
import { defaultApi } from "./api";
import { USER_UPDATE_USER_DETAILS } from "./constant";

export const getProfileFromResponse = (response) => response?.data?.data || {};

export const getProfileUserId = (profile) =>
  profile?.id || profile?.user_id || profile?.customer_id || null;

export function getUserDetails() {
  const token = getToken();
  return defaultApi.get("/auth/get-user-details", {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
      token,
    },
  });
}

export function updateUserProfile(formData) {
  const token = getToken();
  return defaultApi.post(USER_UPDATE_USER_DETAILS, formData, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
      token,
    },
  });
}

export function addContact(data) {
  return defaultApi.post(`web/sendInquiry`, data);
}
